exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".darken-pseudo[data-v-4b191e60]{position:relative}.darken-pseudo[data-v-4b191e60]:after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;display:block;background-color:rgba(0,0,0,.5)}.darken-with-text span[data-v-4b191e60]{z-index:1;top:40%}.darken-with-text span[data-v-4b191e60],p[data-v-4b191e60]{margin:0;font-size:2em;text-align:center;color:#fff;position:absolute;left:50%;transform:translateX(-50%) translateY(-50%)}p[data-v-4b191e60]{z-index:3;top:60%}#headline[data-v-4b191e60]{top:105px;min-width:195px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b191e60","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HomeCard.vue
// module id = 575
// module chunks = 0